import { ctaOptions } from "~src/data/ctaOptions.ts";
import { videoLengths } from "~src/data/videoLengths.ts";
import { BrandMappingFilters } from "~src/hooks/useBrandMappingV3";
import { COUNTRIES , MAINCOUNTRIES} from "~src/data/countries";
import { logError } from "~src/utils/logger";
export const findLabelByValues = (
  countryCodes: string[],
  fullCountriesList?: boolean,
): string => {
  const countries = fullCountriesList
    ? [{ label: "All", code: "all" }, ...COUNTRIES]
    : MAINCOUNTRIES;
  const labels = countryCodes
    .map((code) => {
      const foundCountry = countries.find((item) => item.code === code);
      return foundCountry ? foundCountry.label : null;
    })
    .filter((label): label is string => label !== null);

  return labels.join(", ");
};

export const ctaNamesByKey = (ctaKey: string[]): string | null => {
  const foundTitles: string[] = [];

  ctaKey.forEach((ctaKey) => {
    const foundCountry = ctaOptions.find((item) => item.key === ctaKey);
    if (foundCountry) {
      foundTitles.push(foundCountry.title);
    }
  });

  return foundTitles.length > 0 ? foundTitles.join(", ") : null;
};

export const videoLengthByKey = (lengthKey: string[]) => {
  const foundTitles: string[] = [];

  lengthKey.forEach((lengthKey) => {
    const foundCountry = videoLengths.find((item) => item.value === lengthKey);
    if (foundCountry) {
      foundTitles.push(foundCountry.label);
    }
  });
  return foundTitles.length > 0 ? foundTitles.join(", ") : null;
};

export const engagementRangeByKey = (engagementRange: string) => {
  const [minValue, maxValue] = engagementRange.split("__").map(Number);
  return `${minValue} - ${maxValue}`;
};

export const formatDateRange = (dateRange: string) => {
  try {
    if (!dateRange || !dateRange.includes("__")) {
      return "Invalid date range";
    }
    
    const [startDateStr, endDateStr] = dateRange.split("__");

    // Validate date strings
    if (!startDateStr || !endDateStr) {
      return "Invalid date range";
    }

    // Convert start and end date strings to Date objects with validation
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    
    // Check if dates are valid
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return "Invalid date range";
    }

    // Format date objects to the desired output format
    const formattedStartDate = startDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const formattedEndDate = endDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    // Create the final formatted date range string
    return `${formattedStartDate} to ${formattedEndDate}`;
  } catch (error) {
    logError(`Error formatting date range: ${error}`);
    return "Invalid date range";
  }
};

export const handleDelete = (
  key: string,
  filters: BrandMappingFilters | undefined,
  onFilterUpdate?: (filters: BrandMappingFilters | undefined) => void,
) => {
  const updatedSetFilters = { ...filters };
  delete (updatedSetFilters as any)[key];

  if (updatedSetFilters && onFilterUpdate) {
    onFilterUpdate(updatedSetFilters);
  }
};
